import { Chip } from 'primereact/chip';
import React from 'react';

export const CustomChip = (props) => {
    return (
        <Chip label={props.label} image={props.avatar}
              className="mb-2" imageAlt="" style={{ fontSize: "12px" }} removable={props.removable} />
    );
}